module.exports = __webpack_public_path__ + "static/media/iphone 12 pro.94c65475.jpg";